var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_511_44473"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_511_44473)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 0,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.5,22.0000001C33.5,21.44771528,33.052285,21,32.5,21L22.5,21C21.9477153,21,21.5,21.44771528,21.5,22.0000001L18.5,22L18.5,23.5L21.5,23.5C21.5,24.0522847,21.9477153,24.5,22.5,24.5L28.578706,24.5C28.659273,24.5,28.739546,24.4902635,28.817778,24.4710019L32.739073,23.5055315C33.185926,23.3955109,33.5,22.9947281,33.5,22.5345298L33.5,22.0000001Z",
    fillRule: "evenodd",
    fill: "#C00000",
    fillOpacity: 0.30000001192092896
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,45.5000001C27,44.94771528,26.552284999999998,44.5,26,44.5L16,44.5C15.4477153,44.5,15,44.94771528,15,45.5000001L12,45.5L12,47L15,47C15,47.5522847,15.4477153,48,16,48L22.078706,48C22.159273,48,22.239546,47.9902635,22.317778,47.9710019L26.239072999999998,47.005531500000004C26.685926000000002,46.8955109,27,46.4947281,27,46.0345298L27,45.5000001Z",
    fillRule: "evenodd",
    fill: "#C00000",
    fillOpacity: 0.30000001192092896
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.750003,19L35.4285717,19L35.4285717,20.5L39.750003,20.5Q44.306353,20.5,47.528177,23.7218251Q50.750004000000004,26.9436522,50.750004000000004,31.499999000000003Q50.750001999999995,36.056349,47.528175000000005,39.278175000000005Q44.306351,42.5,39.750002,42.5L29,42.5L29,44L39.750002,44Q44.927673,44,48.588837,40.338837Q52.250001999999995,36.677671000000004,52.250004000000004,31.499999000000003Q52.250004000000004,26.3223305,48.588839,22.6611648Q44.927675,19,39.750003,19Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.25,22.5L34.25,17L35.75,17L35.75,22.5L34.25,22.5Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.25,23.499999L17.25,16L18.75,16L18.75,23.499999L17.25,23.499999Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.25,46.999999L11.25,39.5L12.75,39.5L12.75,46.999999L11.25,46.999999Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.25,46L28.25,40.5L29.75,40.5L29.75,46L28.25,46Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,-24,24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.178281300000002,46.351218700000004Q23.249999,46.108479,23.249999,45.8553629L23.249999,41.0000001Q23.249999,40.27512646,22.7374363,39.76256323Q22.2248731,39.24999994,21.4999995,39.25L16.99999988,39.25Q16.27512616,39.25,15.76256314,39.76256318Q15.24999994,40.2751264,15.25,41.0000001L15.25,45.8553624Q15.25,46.1084771,15.32171899,46.351218700000004L16.25081635,49.4958553Q16.41562161,50.053658,16.88154,50.401829Q17.3474574,50.749999,17.9290973,50.749999L20.5709028,50.749999Q21.152542099999998,50.749999,21.6184597,50.401829Q22.0843782,50.053658,22.2491837,49.4958553L23.178281300000002,46.351218700000004ZM21.7499995,41.0000001L21.7499995,45.8553624Q21.7499995,45.8915243,21.7397542,45.926199L20.810657,49.0708361Q20.7577224,49.25,20.5709028,49.25L17.9290973,49.25Q17.7422777,49.25,17.689343,49.0708361L16.76024556,45.926199Q16.75,45.8915219,16.75,45.8553624L16.75,41.0000001Q16.75,40.75,16.99999988,40.75L21.4999995,40.75Q21.7499995,40.75,21.7499995,41.0000001Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,5.5,-5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.178281300000002,22.8512187Q29.249999,22.608479,29.249999,22.3553629L29.249999,17.5000001Q29.249999,16.77512646,28.7374363,16.26256323Q28.2248731,15.74999994,27.4999995,15.75L22.99999988,15.75Q22.27512616,15.75,21.76256314,16.26256318Q21.24999994,16.7751264,21.25,17.5000001L21.25,22.3553624Q21.25,22.6084771,21.32171899,22.8512187L22.25081635,25.995855300000002Q22.41562161,26.553658,22.88154,26.901829Q23.3474574,27.249999000000003,23.9290973,27.249999000000003L26.5709028,27.249999000000003Q27.152542099999998,27.249999000000003,27.6184597,26.901829Q28.0843782,26.553658,28.2491837,25.995855300000002L29.178281300000002,22.8512187ZM27.7499995,17.5000001L27.7499995,22.3553624Q27.7499995,22.3915243,27.7397542,22.426199L26.810657,25.5708361Q26.7577224,25.75,26.5709028,25.75L23.9290973,25.75Q23.7422777,25.75,23.689343,25.5708361L22.76024556,22.426199Q22.75,22.3915219,22.75,22.3553624L22.75,17.5000001Q22.75,17.25,22.99999988,17.25L27.4999995,17.25Q27.7499995,17.25,27.7499995,17.5000001Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.d26587a32269ca9717a03e1352dd6593.svg";
export { ForwardRef as ReactComponent };